export function setInput(key, value, valid) {
  return (dispatch) => {
    dispatch({ type: 'data-' + key, key, value, valid });
  };
}
